module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10221.124642b2.jpg";